var has  = require('./$.has')
  , hide = require('./$.hide')
  , TAG  = require('./$.wks')('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))hide(it, TAG, tag);
};


/*****************
 ** WEBPACK FOOTER
 ** /Users/spikelny/Desktop/projects/art/fastcash/~/babel-core/~/core-js/modules/$.tag.js
 ** module id = 37
 ** module chunks = 0
 **/